import { Fragment, useMemo } from "react";
import { Breadcrumbs, Btn } from "../../../AbstractElements";
import { Card, CardBody, Col, Container, Row, Badge, Button } from "reactstrap";
import HeaderCard from "../../../Components/Common/Component/HeaderCard";
import { useDataFetch } from "../../Hooks/Use-data-fetch";
import DataTable from "../../Components/DataTable";
import { createColumnHelper } from "@tanstack/react-table";

export const CountryList = () => {
  const { getData } = useDataFetch();

  const { data, isLoading } = getData(
    ["countries"],
    "/product/all/countries",
    {
      enabled: true,
    }
  );

  const columnHelper = createColumnHelper();

  const columns = useMemo(() => [
    columnHelper.accessor("name", {
      header: "Nombre",
      cell: info => (
        <strong>{info.getValue()}</strong>
      ),
    }),
    columnHelper.accessor("status", {
      header: "Estado",
      cell: info => {
        const status = info.getValue();
        return (
          <Badge color={status ? "success" : "danger"}>
            {status ? "Activo" : "Inactivo"}
          </Badge>
        );
      },
    }),
    columnHelper.display({
      id: "acciones",
      header: "Acciones",
      cell: props => {
        const isActive = props.row.original.status;
        const text = isActive ? "Inactivar" : "Activar";
        const color = isActive ? "danger" : "success";

        return (
          <Button color={color} size="sm">
            {text}
          </Button>
        );
      },
    }),
  ], []);

  return (
    <Fragment>
      <Breadcrumbs parent="Otros" title="Lista de Países" mainTitle="Países" />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <HeaderCard title="Gestión de Países" />
              <CardBody>
                <>
                  {data?.data?.countries?.length ? (
                    <DataTable data={data.data.countries} columns={columns} progressPending={isLoading} />
                  ) : (
                    <p className="text-center text-muted">No hay países registrados.</p>
                  )}
                </>

              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};
